import { atom, selector } from "recoil";
import { createDataRequest, assignDataRequest, completeDataRequest } from "../../../api/controller/FaultLogController";
import { pageState } from "../../../state/GlobalState";
import { permissionState } from "../../../api/state/AuthState";
import moment from "moment";

export const faultLogListState = atom({
    key: 'faultLogListState',
    default: [],
})
export const faultLogCategoryState = atom({
	key: 'faultLogCategoryState',
	default:{
		data:[],
		ovf:false,
	}
})
export const faultLogGroupState = atom({
	key: 'faultLogGroupState',
	default:{
		data:[],
		ovf:false,
	}
})

export const modalConfigDefault = { size: "md", wizard: false }

export const faultLogMonthListState = atom({
	key: 'faultLogMonthListState',
	default:{
		data: [
            { label: moment().format('MMMM YYYY'), value: moment().format("YYYY-MM") }
        ],
		ovf:false,
	}
})
export const faultLogFilterMonthValueState = atom({
    key: 'faultLogFilterMonthValueState',
    default: { label: moment().format('MMMM YYYY'), value: moment().format("YYYY-MM") },
})
export const faultLogFilterState = selector({
    key: 'faultLogFilterState',
    get: ({ get }) => ([
        {
            label: 'Month',
            size: 6,
            offset: 6,
            required: true,
            type: 'select',
            value: get(faultLogFilterMonthValueState),
            list: get(faultLogMonthListState),
        },
    ]),
    set: ({ set }, e) => {
        if(e.filterLabel === 'Month'){
            set(faultLogFilterMonthValueState, e.value)
        }
    }
})


export const formModes = {
    create: [ { name: 'Default Create', action: createDataRequest } ], 
    update: [ { name: 'Default Update', action: assignDataRequest, closeOnSubmit: true }, { name: 'Default Update', action: completeDataRequest, closeOnSubmit: true } ],
    view: [ { name: 'Default View' } ],
}

export const faultLogDataStructureState = selector({
    key: 'faultLogDataStructureState',
    get: ({ get }) => (
        [

			{
                label: 'Tenant',
                type: 'text',
                field: 'tenant.display_name',
                order: { table: 0.5, form: 0.5 }, 
                table: { customRender: (value, params) => <span title={value}>{value}</span>, maxWidth: 300 },
                create: [{ enabeld: false }], update: [{ enabled: false }, { enabled: false }], view: [{ enabled: true, size: { xs: 12, md: 12 }  }], 
            },
			{ 
                label: 'Category',
                type: 'text',
                field: 'category_text',
                order: { table: 1, form: 1 }, 
                table: { customRender: (_, params) => <span title={params?.data["category_text"]}>{params?.data["category_text"]}</span> },
                create: [{ enabled: true, size: { xs: 12, md: 12 }  }], update: [{ enabled: false }, { enabled: false }], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Details',
                type: 'textarea',
                order: { form: 3 }, 
                create: [{ enabled: true, size: { xs: 12, md: 12 } , attributes: { maxLength: '225', rows: '3' } }], update: [{ enabled: false }, { enabled: false }], view: ['same_as:create.0'], 
            },
			{ 
                label: 'Attachments',
                type: 'repeater',
                order: { form: 4 },
                create: [{ enabled: true, size: { xs: 12, md: 12 }, deleteBtnSize: 2, repeatLabel: false }], update: [{ enabled: false }, { enabled: false }], view: ['same_as:create.0'],
                children: [
                    { 
                		label: 'Name',
                		type: 'text',
                		order: { form: 1 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: [{ enabled: false }, { enabled: false }], view: ['same_as:create.0'], 
            		},
					{ 
                		label: 'File',
                		type: 'file',
                		order: { form: 2 }, 
                		create: [{ enabled: true, size: { xs: 12, md: 6 }  }], update: [{ enabled: false }, { enabled: false }], view: ['same_as:create.0'], 
            		},
					
                ]
            },
			// { 
            //     label: 'Priority',
            //     type: 'select',
            //     rootValue: true,
            //     order: { table: 2.2, form: 5.1 }, 
            //     table: { maxWidth: 100 },
            //     create: [{ enabled: false }], update: [{ enabled: true, size: { xs: 12, md: 12 }  }, { enabled: false }], view: ['same_as:update.0'], 
			// 	list: {
            //         ovf: false,
            //         data: [
            //             { label: 'LOW', value: 'LOW' },
            //             { label: 'MEDIUM', value: 'MEDIUM' },
            //             { label: 'HIGH', value: 'HIGH' },
            //         ]
            //     },
            // },
			{ 
                label: 'Response',
                type: 'textarea',
                order: { form: 6 }, 
                create: [{ enabled: false }], update: ['same_as:create.0', { enabled: true, size: { xs: 12, md: 12 } , attributes: { maxLength: '225', rows: '3' } }], view: ['same_as:update.1'], 
            },
			{ 
                label: 'Logged Time',
                field: 'created_time',
                type: 'datepicker',
                order: { table: 3, form: 6 }, 
				table: { dateFormat: 'D MMM | HH:mm', maxWidth: 150 },
                create: [{ enabled: false }], update: ['same_as:create.0','same_as:create.0'], view: [{ enabled: true, size: { xs: 12, md: 6 } }], 
            },
			// { 
            //     label: 'Assigned Time',
            //     field: 'assigned_at',
            //     type: 'datepicker',
            //     order: { table: 3.5, form: 7 }, 
			// 	table: { dateFormat: 'D MMM | HH:mm', maxWidth: 150 },
            //     create: [{ enabled: false }], update: ['same_as:create.0','same_as:create.0'], view: [{ enabled: true, size: { xs: 12, md: 6 } }], 
            // },
			{ 
                label: 'Completed Time',
                field: 'completed_at',
                type: 'datepicker',
                order: { form: 8 }, 
				table: { dateFormat: 'D MMM | HH:mm' },
                create: [{ enabled: false }], update: ['same_as:create.0','same_as:create.0'], view: [{ enabled: true, size: { xs: 12, md: 6 } }], 
            },
			{ 
                label: 'Status',
                type: 'text',
                order: { table: 4, form: 9 }, 
                table: { maxWidth: 130 },
                create: [{ enabled: false }], update: ['same_as:create.0','same_as:create.0'], view: [{ enabled: true, size: { xs: 12, md: 12 }  }], 
            },

        ].filter((v)=>{
            const page = get(pageState)
            const permissions = get(permissionState)
            if(! v.permission){
                return true
            }
            let absolute = false;
            if(v.permission.substr(0,1) === ":"){
                absolute = true;
                v.permission = v.permission.substr(1)
            }
            v.permission = absolute ? v.permission : v.permission + "-" + page
            return permissions?.includes(v.permission)
        })
    )
})
